/**
 * Shared Component properties for accessing/mutating the locale/translations
 */
var LocaleMixin = {
  computed: {
    translationsLoaded () {
      return this.$store.getters['localeModule/translationsLoaded']
    }
  }
}

export default LocaleMixin
